// React builder
import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import InventoryIcon from '@mui/icons-material/Inventory';
import PersonIcon from '@mui/icons-material/Person';
import BorderColorIcon from '@mui/icons-material/BorderColor';
// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";

// Branch
import BranchIndex from './components/pages/branch/Index';
import BranchCreate from "./components/pages/branch/Create";
import BranchEdit from "./components/pages/branch/Edit";

// User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

// Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

// Company Logo
import CompanyLogo from '../src/components/pages/CompanyLogo/CompanyLogo.png';

//Home
import Home from "./components/pages/Home";
// PurchaseOrder
import PurchaseOrderIndex from "./components/pages/PurchaseOrder/Index";
import PurchaseOrderCreate from "./components/pages/PurchaseOrder/Create";
import PurchaseOrderDetails from "./components/pages/PurchaseOrder/Details";
import PurchaseOrderEdit from "./components/pages/PurchaseOrder/Edit";

//Item 
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";
import ItemIndex from "./components/pages/Item/Index";

//Category
import CategoryIndex from "./components/pages/ItemCategory/Index";

//Purchase
import PurchaseIndex from "./components/pages/Purchase/Index";
import PurchaseCreate from "./components/pages/Purchase/Create";
import PurchaseDetails from "./components/pages/Purchase/Details";
import PurchaseEdit from "./components/pages/Purchase/Edit";
// Sale
import SaleIndex from "./components/pages/Sale/Index";
import SaleCreate from "./components/pages/Sale/Create";
import SaleDraftDetails from "./components/pages/Sale/DraftDetails";
import SaleDraftEdit from "./components/pages/Sale/DraftEdit";
import SaleDetails from "./components/pages/Sale/Details";
import SaleEdit from "./components/pages/Sale/Edit";

//Styles
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";

//Master 
import MasterIndex from "./components/pages/Master/Index";
import AccountHeadEdit from "./components/pages/Master/AHDEdit";
import BKEdit from "./components/pages/Master/BankEdit";
import StaffEdit from "./components/pages/Master/StaffEdit";
import AssetEdit from "./components/pages/Master/AssetEdit";
import COSEdit from "./components/pages/Master/CsEdit";
import otherEdit from "./components/pages/Master/OtherEdit";
import CapitalEdit from "./components/pages/Master/CapitalEdit";

//sale order
import SaleOrderIndex from "./components/pages/SaleOrder/Index";
import SaleOrderCreate from "./components/pages/SaleOrder/Create";
import SaleOrderDetails from "./components/pages/SaleOrder/Details";
import SaleOrderEdit from "./components/pages/SaleOrder/Edit";
// Receipt
import ReceiptIndex from "./components/pages/Receipt/Index";
import ReceiptCreate from "./components/pages/Receipt/Create";
import ReceiptDetails from "./components/pages/Receipt/Details";
import ReceiptEdit from "./components/pages/Receipt/Edit";

// Payment
import PaymentIndex from "./components/pages/Payment/Index";
import PaymentCreate from "./components/pages/Payment/Create";
import PaymentDetails from "./components/pages/Payment/Details";
import PaymentEdit from "./components/pages/Payment/Edit";
// Payment and Receipt
import PaymentAndReceiptIndex from "./components/pages/PaymentAndReceipt/Index";
import PaymentAndReceiptCreate from "./components/pages/PaymentAndReceipt/Create";
import PaymentAndReceiptDetails from "./components/pages/PaymentAndReceipt/Details";
import PaymentAndReceiptEdit from "./components/pages/PaymentAndReceipt/Edit";
// JournalEntry
import JournelEntry from "./components/pages/JournalEntryPage/Create";
import JournelEntryIndex from "./components/pages/JournalEntryPage/Index";
import JournalEntryEdit from "./components/pages/JournalEntryPage/Edit";
import JournalEntryDetails from "./components/pages/JournalEntryPage/Details";
// Income Expense
import IncomeExpenseIndex from "./components/pages/IncomeExpense/Index";
import IncomeExpenseCreate from "./components/pages/IncomeExpense/Create";
import IncomeExpenseDetails from "./components/pages/IncomeExpense/Details";
import IncomeExpenseEdit from "./components/pages/IncomeExpense/Edit";
//Report 
import LedgerReport from "./components/pages/Report/LedgerReport";
import Stock from "./components/pages/Report/Stock";
import SaleRegister from "./components/pages/Report/SaleRegister";
import PurchaseRegisterReport from "./components/pages/Report/PurchaseRegister";
import CreditorDebitorReport from "./components/pages/Report/CreditorDebitor";
import CashBook from "./components/pages/Report/CashBook";

//Auth
import { AuthProvider, useAuth } from "./AuthContext";

//Logout
import Logout from "./Logout";

//SessionTimeOut
import SessionTimeout from "./SessionTimeout";

//App Icons
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import AddCardIcon from '@mui/icons-material/AddCard';
import StoreIcon from '@mui/icons-material/Store';
import CategoryIcon from '@mui/icons-material/Category';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AnimationIcon from '@mui/icons-material/Animation';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PostAddIcon from '@mui/icons-material/PostAdd';
import PaymentsIcon from '@mui/icons-material/Payments';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import NoteIcon from '@mui/icons-material/Note';
import ArticleIcon from '@mui/icons-material/Article';

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleOtherClick = () => {
    setOtherOpen(!otherOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };

  //const { companyName, companyId, isSuperAdmin, superCompanyId, roleName } = useAuth();
  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, username } = useAuth();

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />

        <AppBar position="static" style={{ backgroundColor: '#1F2544', height: '55px' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px', position: 'relative' }}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            <Typography
              variant="h6"
              component="div"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}
            >
              {/* Left Section */}
              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Link
                  to="/Home"
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <FiHome style={{ marginRight: '8px' }} />
                  <Typography
                    variant="h6"
                    //className="dual-text"
                    component="div"
                    style={{ marginLeft: '10px', fontWeight: 'bolder', position: 'relative' }}
                  >
                    {/* <span style={{ color: 'whitesmoke' }}>{companyName.slice(0, 1)}</span>
                    <span style={{ color: 'whitesmoke' }}>{companyName.slice(1, 2)}</span>
                    <span style={{ color: '#F4CE14' }}>{companyName.slice(2)}</span> */}
                    {companyName}
                  </Typography>
                </Link>
              </div>

              {/* Right Section */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Typography
                  component="div"
                  style={{
                    fontWeight: 'bolder',
                    color: 'whitesmoke',
                    fontFamily: 'monospace',
                    fontSize: '14px'
                  }}
                >
                  👤 {username}
                </Typography>
                <div className="white-icon" style={{ marginTop: '5px' }}>
                  <Logout />
                </div>
              </div>
            </Typography>

          </Toolbar>
        </AppBar>

        {/* <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose} style={{ backgroundColor: '#E1F0DA' }}> */}
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={handleDrawerClose}
          PaperProps={{
            style: { backgroundColor: '#000043' }
          }}
        >

          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>

            <Typography variant="h6" component="div" style={{ marginLeft: '15px', fontWeight: 'bolder', position: 'relative', color: 'whitesmoke' }}>
              {companyName}
            </Typography>

          </div>
          <List>
            <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
              <ListItemText style={{ color: 'white' }} primary="HOME" />
            </ListItem>

            <ListItem button onClick={handleMasterClick}>
              <ListItemText style={{ color: 'white' }} primary="MASTER" />
              {masterOpen ? <ExpandLess style={{ color: 'white' }} /> : <ExpandMore style={{ color: 'white' }} />}
            </ListItem>

            <Collapse in={masterOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px', backgroundColor: '#C3D1EB' }}>
                <ListItem button component={NavLink} to="/BranchIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <StoreIcon style={{ color: '#795757', height: '20px' }} /><ListItemText primary="Branch" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/MasterIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <PersonIcon style={{ color: 'black' }} /> <ListItemText primary="Registration" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/CategoryIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <CategoryIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Category" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <ListAltIcon style={{ color: '#3C3D37', height: '20px' }} /><ListItemText primary="Item" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>
            </Collapse>

            <ListItem button onClick={handleItemClick}>
              <ListItemText style={{ color: 'white' }} primary="TRANSACTION" />
              {itemOpen ? <ExpandLess style={{ color: 'white' }} /> : <ExpandMore style={{ color: 'white' }} />}
            </ListItem>

            <Collapse in={itemOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px', backgroundColor: '#C3D1EB' }}>
                <ListItem button component={NavLink} to="/PurchaseOrderIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <AnimationIcon style={{ color: '#C40C0C', height: '20px' }} /><ListItemText primary="Purchase Order" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PurchaseIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <InventoryIcon style={{ color: '#134B70', height: '20px' }} /><ListItemText primary="Purchase" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleOrderIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <BorderColorIcon style={{ color: '#800000', height: '20px' }} /><ListItemText primary="Sale Order" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <ShoppingBagIcon style={{ color: '#3B1C32', height: '20px' }} /><ListItemText primary="Sale" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>
            </Collapse>

            <ListItem button onClick={handleOtherClick}>
              <ListItemText style={{ color: 'white' }} primary="ACCOUNTS" />
              {otherOpen ? <ExpandLess style={{ color: 'white' }} /> : <ExpandMore style={{ color: 'white' }} />}
            </ListItem>

            <Collapse in={otherOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px', backgroundColor: '#C3D1EB' }}>

                <ListItem button component={NavLink} to="/PaymentIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <PaymentIcon style={{ color: '#C40C0C', height: '20px' }} /><ListItemText primary="Payment" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ReceiptIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <ReceiptLongIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="Receipt" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PaymentAndReceiptIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <AccountBalanceIcon style={{ color: '#3B1C32', height: '20px' }} /><ListItemText primary="Payment & Receipt" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/JournelEntryIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <PostAddIcon style={{ color: 'darkblue', height: '20px' }} /><ListItemText primary="Journal Entry " style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/IncomeExpenseIndex" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <PaymentsIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Income Expense" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>


              </List>
            </Collapse>

            <ListItem button onClick={handleReportClick}>
              <ListItemText style={{ color: 'white' }} primary="REPORT" />
              {reportOpen ? <ExpandLess style={{ color: 'white' }} /> : <ExpandMore style={{ color: 'white' }} />}
            </ListItem>


            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px', backgroundColor: '#C3D1EB' }}>

                <ListItem button component={NavLink} to="/CashBook" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <CurrencyRupeeIcon style={{ color: 'blue#9B3922violet', height: '20px' }} /><ListItemText primary="Cash Book" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/LedgerReport" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <LibraryBooksIcon style={{ color: '#3B1C32', height: '20px' }} /><ListItemText primary="Ledger" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/Stock" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <SummarizeIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Stock" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CreditorDebitorReport" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <SummarizeIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Creditors/Debitors" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PurchaseRegisterReport" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <NoteIcon style={{ color: '#3B1C32', height: '20px' }} /><ListItemText primary="Purchase Register" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>


                <ListItem button component={NavLink} to="/SaleRegister" activeClassName="selected" onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: '#FFFFEC' }
                  }}
                >
                  <ArticleIcon style={{ color: '#134B70', height: '20px' }} /><ListItemText primary="Sale Register" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
              </List>
            </Collapse>

            <ListItem button onClick={handleUserClick}>
              <ListItemText style={{ color: 'white' }} primary="USER" />
              {userOpen ? <ExpandLess style={{ color: 'white' }} /> : <ExpandMore style={{ color: 'white' }} />}
            </ListItem>

            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px', backgroundColor: '#C3D1EB' }}>
                {roleName == "SuperAdmin" && (
                  <ListItem
                    button
                    component={NavLink}
                    to="/UserIndex"
                    activeClassName="selected"
                    onClick={handleDrawerClose}
                    sx={{
                      '&:hover': { backgroundColor: 'grey' }
                    }}
                  >
                    <PeopleAltIcon style={{ color: 'blueviolet', height: '20px' }} />
                    <ListItemText primary="User" style={{ marginLeft: '3px', color: 'black' }} />
                  </ListItem>
                )}

                {roleName == "SuperAdmin" && (
                  <ListItem
                    button
                    component={NavLink}
                    to="/RoleIndex"
                    activeClassName="selected"
                    onClick={handleDrawerClose}
                    sx={{
                      '&:hover': { backgroundColor: 'grey' }
                    }}
                  >
                    <AccessibilityIcon style={{ color: 'darkorange', height: '20px' }} />
                    <ListItemText primary="Role" style={{ marginLeft: '3px', color: 'black' }} />
                  </ListItem>
                )}

                <ListItem
                  button
                  component={NavLink}
                  to="/PasswordChange"
                  activeClassName="selected"
                  onClick={handleDrawerClose}
                  sx={{
                    '&:hover': { backgroundColor: 'grey' }
                  }}
                >
                  <SecurityIcon style={{ color: 'darkolivegreen', height: '20px' }} />
                  <ListItemText primary="Change Password" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
              </List>
            </Collapse>

          </List>
        </Drawer>

        <Container maxWidth="xl">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/Home" exact component={Home} />

            {/* Company */}
            <Route path="/CompanyIndex" component={CompanyIndex} />
            <Route path="/CompanyCreate" component={CompanyCreate} />
            <Route path="/CompanyEdit/:id" component={CompanyEdit} />

            {/* Branch */}
            <Route path="/BranchIndex" component={BranchIndex} />
            <Route path="/BranchCreate" component={BranchCreate} />
            <Route path="/BranchEdit/:id" component={BranchEdit} />

            {/* Item */}
            <Route path="/ItemIndex" component={ItemIndex} />
            <Route path="/ItemCreate" component={ItemCreate} />
            <Route path="/ItemEdit/:id" component={ItemEdit} />

            {/* Category */}
            <Route path="/CategoryIndex" component={CategoryIndex} />


            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />

            {/* Role */}
            <Route path="/RoleIndex" component={RoleIndex} />
            <Route path="/RoleDetail/:id" component={RoleDetail} />
            {/* PurchaseOrder */}
            <Route path="/PurchaseOrderIndex" component={PurchaseOrderIndex} />
            <Route path="/PurchaseOrderCreate" component={PurchaseOrderCreate} />
            <Route path="/PurchaseOrderDetails/:id" component={PurchaseOrderDetails} />
            <Route path="/PurchaseOrderEdit/:id" component={PurchaseOrderEdit} />
            {/* Purchase */}
            <Route path="/PurchaseIndex" component={PurchaseIndex} />
            <Route path="/PurchaseCreate/:id" component={PurchaseCreate} />
            <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />
            <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />

            <Route path="/MasterIndex" component={MasterIndex} />

            {/* Masteredit id as masterId and mtypeid as masterTypeid  */}
            <Route path="/AccountHeadEdit/:id/:Mtypeid" component={AccountHeadEdit} />
            <Route path="/AssetEdit/:id/:Mtypeid" component={AssetEdit} />
            <Route path="/BKEdit/:id/:Mtypeid" component={BKEdit} />
            <Route path="/StaffEdit/:id/:Mtypeid" component={StaffEdit} />
            <Route path="/CapitalEdit/:id/:mid" component={CapitalEdit} />
            {/* <Route path="/otherEdit/:id/Mtypeid" component={otherEdit} /> */}
            <Route path="/COSEdit/:id/:Mtypeid" component={COSEdit} />

            {/* SaleOrder */}
            <Route path="/SaleOrderIndex" component={SaleOrderIndex} />
            <Route path="/SaleOrderCreate" component={SaleOrderCreate} />
            <Route path="/SaleOrderDetails/:id" component={SaleOrderDetails} />
            <Route path="/SaleOrderEdit/:id" component={SaleOrderEdit} />
            {/* Sale */}
            <Route path="/SaleIndex" component={SaleIndex} />
            <Route path="/SaleCreate" component={SaleCreate} />
            <Route path="/SaleDraftDetails/:id" component={SaleDraftDetails} />
            <Route path="/SaleDraftEdit/:id" component={SaleDraftEdit} />
            <Route path="/SaleDetails/:id" component={SaleDetails} />
            <Route path="/SaleEdit/:id" component={SaleEdit} />
            {/* Receipt */}
            <Route path="/ReceiptIndex" component={ReceiptIndex} />
            <Route path="/ReceiptCreate" component={ReceiptCreate} />
            <Route path="/ReceiptDetails/:id" component={ReceiptDetails} />
            <Route path="/ReceiptEdit/:id" component={ReceiptEdit} />

            {/* Payment */}
            <Route path="/PaymentIndex" component={PaymentIndex} />
            <Route path="/PaymentCreate" component={PaymentCreate} />
            <Route path="/PaymentDetails/:id" component={PaymentDetails} />
            <Route path="/PaymentEdit/:id" component={PaymentEdit} />
            {/* Payment And Receipt */}
            <Route path="/PaymentAndReceiptIndex" component={PaymentAndReceiptIndex} />
            <Route path="/PaymentAndReceiptCreate" component={PaymentAndReceiptCreate} />
            <Route path="/PaymentAndReceiptDetails/:id" component={PaymentAndReceiptDetails} />
            <Route path="/PaymentAndReceiptEdit/:id" component={PaymentAndReceiptEdit} />
            {/* JournalEntry */}
            <Route path="/JournelEntry" component={JournelEntry} />
            <Route path="/JournelEntryIndex" component={JournelEntryIndex} />
            <Route path="/JournalEntryEdit/:id" component={JournalEntryEdit} />
            <Route path="/JournalEntryDetails/:id" component={JournalEntryDetails} />
            {/* Income Expense */}
            <Route path="/IncomeExpenseIndex" component={IncomeExpenseIndex} />
            <Route path="/IncomeExpenseCreate" component={IncomeExpenseCreate} />
            <Route path="/IncomeExpenseDetails/:id" component={IncomeExpenseDetails} />
            <Route path="/IncomeExpenseEdit/:id" component={IncomeExpenseEdit} />
            {/* Report */}
            <Route path="/LedgerReport" component={LedgerReport} />
            <Route path="/Stock" component={Stock} />
            <Route path="/SaleRegister" component={SaleRegister} />
            <Route path="/PurchaseRegisterReport" component={PurchaseRegisterReport} />
            <Route path="/CreditorDebitorReport" component={CreditorDebitorReport} />
            <Route path="/CashBook" component={CashBook} />


          </Switch>
        </Container>
      </AuthProvider>
    </Router>
  );
};

export default App;

